import { Star, StarHalf } from 'lucide-react';

const StarRating = ({ rating, maxRating = 5, size = 'md', showValue = true }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = maxRating - fullStars - (hasHalfStar ? 1 : 0);

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const iconSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      <div className="flex">
        {/* Full stars */}
        {Array.from({ length: fullStars }).map((_, i) => (
          <Star 
            key={`full-${i}`} 
            className={`${iconSize} fill-amber-400 text-amber-400`} 
          />
        ))}
        
        {/* Half star */}
        {hasHalfStar && (
          <div className="relative">
            <Star className={`${iconSize} text-slate-200`} />
            <div className="absolute top-0 left-0 overflow-hidden w-1/2">
              <Star className={`${iconSize} fill-amber-400 text-amber-400`} />
            </div>
          </div>
        )}
        
        {/* Empty stars */}
        {Array.from({ length: emptyStars }).map((_, i) => (
          <Star 
            key={`empty-${i}`} 
            className={`${iconSize} text-slate-200`} 
          />
        ))}
      </div>
      
      {showValue && (
        <span className="ml-1 text-sm font-medium text-slate-700">
          {rating.toFixed(1)}/5
        </span>
      )}
    </div>
  );
};

export default StarRating;
